<script lang="ts" setup>

interface Props {
  icon?: string | null;
  fullWidth?: boolean;
  title?: string;
}

defineProps<Props>();

</script>

<template>
  <h5 style="font-weight: 700; font-size: medium;">
    {{ title }}
  </h5>

  <div
    class="input-section"
    :class="{ 'full-width': fullWidth }"
  >
    <div
      v-if="icon || !fullWidth"
      class="icon-container"
    >
      <IonIcon
        class="p-2"
        :class="icon"
      />
    </div>
    <div class="inputs-container">
      <div class="inputs">
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped>
.input-section {
  display: flex;
  align-items: flex-start;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.input-section.full-width {
  flex-direction: column;
  gap: 0;
}

.icon-container {
  margin-top: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-container.placeholder {
  padding: 05.rem;
  background-color: transparent; /* Placeholder for consistent layout */
}

.icon-container ion-icon {
  font-size: 1.5rem;
}

.inputs-container {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  width: 100%;
}

.inputs {
  flex: 1;
}
</style>
